import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var couponRoute = [{
  path: "coupon",
  name: "coupon",
  component: function component() {
    return import("./coupon.vue");
  }
}];